// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e9f23815","977":"e1ab8664"}[chunkId] + ".chunk.js";
};